import { render, staticRenderFns } from "./PatientChartInfo.vue?vue&type=template&id=69674674&scoped=true&"
import script from "./PatientChartInfo.vue?vue&type=script&lang=js&"
export * from "./PatientChartInfo.vue?vue&type=script&lang=js&"
import style0 from "./PatientChartInfo.vue?vue&type=style&index=0&id=69674674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69674674",
  null
  
)

export default component.exports